import React from 'react';
import { Award } from 'lucide-react';

interface BestPickBadgeProps {
  className?: string;
}

/**
 * Small badge indicating this photo is the best pick from a similarity group.
 */
export const BestPickBadge = React.memo(function BestPickBadge({
  className = '',
}: BestPickBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-0.5 rounded-full bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold leading-none text-amber-700 dark:bg-amber-900/40 dark:text-amber-400 ${className}`}
      title="Best pick"
    >
      <Award className="h-2.5 w-2.5" />
      <span className="hidden sm:inline">Best</span>
    </span>
  );
});
